module.exports = __webpack_public_path__ + "img/classificacao.0b26a43f.svg";